import script from "./items_services_manager.vue?vue&type=script&setup=true&lang=js"
export * from "./items_services_manager.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__